import { useState, useEffect } from "react";
import { Box, Typography, useTheme, IconButton } from "@mui/material";
import { GradientIconAccent } from "../../../../../../../components/GradientIcon";
import { WorkspacesFilled, ExpandLessRounded, ExpandMoreRounded } from "@mui/icons-material";

function ThinkingBlock({ content, status = "completed" }) {
  const [expanded, setExpanded] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    if (status === "streaming") {
      setExpanded(true);
    }
    if (status === "completed") {
      setExpanded(false);
    }
  }, [status]);

  return (
    <Box mb={2} mt={0}>
      <Box
        sx={{
          display: "inline-flex",
          cursor: "pointer",
          transition: "background 0.2s",
          borderRadius: 8,
          px: 0.5,
          "&:hover": {
            background: (theme) => theme.palette.action.hover,
          },
        }}
        mb={0.5}
        alignItems={"center"}
        onClick={() => setExpanded(!expanded)}>
        <GradientIconAccent
          Icon={WorkspacesFilled}
          sx={{
            fontSize: 20,
            color: (theme) => theme.palette.bingGrey?.main || "#B0B3B8",
            opacity: 0.6,
          }}
        />
        <Box mr={1} />
        <Typography variant="body2" color="text.secondary">
          {status === "streaming" ? "Thinking" : "Thoughts"}
        </Typography>
        {status === "streaming" && (
          <Typography variant="body2" color="text.secondary" sx={{ width: 10 }}>
            <span className="loadingStyle"></span>
          </Typography>
        )}
        <Box mr={0.5} />
        <IconButton
          size="small"
          edge="end"
          disableRipple
          disableFocusRipple
          sx={{
            "&:hover": {
              backgroundColor: "transparent",
            },
            visibility: status !== "streaming" ? "visible" : "hidden",
          }}>
          {expanded ? (
            <ExpandLessRounded sx={{ color: theme.palette.action.disabled }} />
          ) : (
            <ExpandMoreRounded sx={{ color: theme.palette.action.disabled }} />
          )}
        </IconButton>
      </Box>
      {expanded && (
        <Box ml={4}>
          <Typography color={theme.palette.text.secondary} variant="caption">
            {content}
          </Typography>
        </Box>
      )}
    </Box>
  );
}

export default ThinkingBlock;